import { render, staticRenderFns } from "./PreviewComponent.vue?vue&type=template&id=938b982e&scoped=true"
import script from "./PreviewComponent.vue?vue&type=script&lang=js"
export * from "./PreviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b982e",
  null
  
)

export default component.exports